import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class FeedbackForm {
  public usersIds: string[] = [];

  public rules: { [key: string]: FormValidationFunction[] } = {
    usersIds: [
      (v: string[]) => !!v.length || 'User is required',
    ],
  };
}
